import React, { useContext, useEffect, useState } from "react";
import {
  EventButton,
  StepperBackButton,
} from "../../../User/component/ReUseComps/Button";
import {
  errorPopup,
  successPopup,
  warningPopup,
} from "../../../Utils/ToasterMessage";
import dummyCompanyLogo from "../../../assets/unknownLogo.png";
import { COMPANY_URLS } from "../../../Utils/Company_App_Urls";
import cashMultiple from "../../../assets/cash-multiple.png";
import { useLocation, useParams } from "react-router-dom";
import bagImage from "../../../assets/bag-solid.png";
import { TiLocation } from "react-icons/ti";
import { IoMdShare } from "react-icons/io";
import "./PostedJobDetails.css";
import { Spinner } from "react-bootstrap";
import CompanyContext from "../../Component/ContextAPI/CompanyContext";
import { Skeleton } from "antd";
import { getJobPostedDate } from "../../Component/CustomHook/jobPostedDate";

export default function JobDetails({ singleJobDetails }) {
  const { setCloseJobModalOpen, needTorender } = useContext(CompanyContext);
  const jobId = useParams();
  const location = useLocation();
  const [spinners, setSpinners] = useState(false);

  const formatWebsiteUrl = (url) => {
    if (!url) return null;

    if (url.startsWith("http://") || url.startsWith("https://")) {
      return url;
    }

    return `https://${url}`;
  };

  const displayCleanUrl = (url) => {
    if (!url) return "N/A";
    try {
      const cleanUrl = url.replace(/^(https?:\/\/)?(www\.)?/, "");

      return cleanUrl.split("/")[0];
    } catch {
      return url;
    }
  };

  const shareLink = () => {
    if (navigator.share) {
      navigator
        .share({
          title: "Kaamval job url",
          text: "I found matched interesting job link:",
          url: window.location.href,
        })
        .then((res) => {
          successPopup(res?.data?.message);
        })
        .catch((error) => console.error(error));
    } else {
      alert("Your browser does not support the Web Share.");
    }
  };

  const convertHtmlToText = (htmlString) => {
    const tempElement = document.createElement("div");
    tempElement.innerHTML = htmlString;
    return tempElement.textContent || tempElement.innerText || "";
  };

  const closeJobOpening = (status, id) => {
    if (status === "Open") {
      setCloseJobModalOpen({ status: true, data: { id: id } });
    } else {
      warningPopup("This job has already been closed.");
    }
  };

  useEffect(() => {
    getJobPostedDate(singleJobDetails?.createdAt?.split("T")?.[0]);
  }, [needTorender]);

  const companyWebUrl = formatWebsiteUrl(
    singleJobDetails?.companyProfileDetail?.[0]?.weburl
  );

  return (
    <>
      <div className="job-details-main">
        {singleJobDetails?.title ? (
          <div className="similar-job-card d-flex flex-column gap-2">
            <div className="similar-job-header d-flex flex-sm-row flex-column-reverse align-items-start justify-content-between flex-wrap gap-2 mb-3">
              <div className="d-flex align-items-center gap-3">
                <div className="compy-logo-box">
                  <img
                    src={
                      singleJobDetails?.companyProfileDetail?.[0]
                        ?.companylogo || dummyCompanyLogo
                    }
                    alt="Company logo"
                    onError={(e) => {
                      e.target.src = dummyCompanyLogo;
                    }}
                  />
                </div>
                <div className="compy-title-descr">
                  <h1 className="d-flex align-items-center gap-2">
                    {singleJobDetails?.title}
                    {singleJobDetails?.status === "Open" ? (
                      <span className="active-status closed-status ms-2">
                        <div className="green_dot" /> Open
                      </span>
                    ) : (
                      <span className="closed-status ms-2">
                        <div className="red_dot" />
                        Closed
                      </span>
                    )}
                  </h1>
                  <p>
                    {singleJobDetails?.companyProfileDetail?.[0]?.companyName ||
                      "N/A"}
                  </p>
                  {companyWebUrl && (
                    <a
                      className="text-break"
                      href={companyWebUrl}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {displayCleanUrl(companyWebUrl)}
                    </a>
                  )}
                </div>
              </div>
              <p className="m-0 d-flex flex-column">
                <span>
                  {getJobPostedDate(singleJobDetails?.createdAt?.split("T"))}
                </span>
              </p>
            </div>

            {/* Rest of the component remains the same */}
            <div className="compay-benif d-flex align-items-start justify-content-start flex-wrap gap-2 mb-2">
              <div>
                <img src={bagImage} alt="Experience icon" />
                <span>{singleJobDetails?.experience || "N/A"}</span>
              </div>
              {singleJobDetails?.salaryType === "Fixed Salary" && (
                <div>
                  <img src={cashMultiple} alt="Salary icon" />
                  <span>
                    {singleJobDetails?.FixedSalary
                      ? `${singleJobDetails?.FixedSalary} LPA`
                      : "N/A"}
                  </span>
                </div>
              )}
              {singleJobDetails?.salaryType === "Salary Range" && (
                <div>
                  <img src={cashMultiple} alt="Salary range icon" />
                  <span>
                    {singleJobDetails?.minSalary
                      ? `${singleJobDetails?.minSalary} - ${singleJobDetails?.maxSalary} LPA`
                      : "N/A"}
                  </span>
                </div>
              )}
              {singleJobDetails?.salaryType === "Not Disclose" && (
                <div>
                  <img src={cashMultiple} alt="Salary icon" />
                  <span>Not disclosed</span>
                </div>
              )}
              <div>
                <TiLocation color="#4B4B4B" fontSize={24} />
                <span>{singleJobDetails?.workPlace || "N/A"}</span>
              </div>
            </div>

            <div className="highlight-skills d-flex align-items-center flex-wrap gap-2 mb-2">
              <div>{singleJobDetails?.deparmentType || "N/A"}</div>
              <div>{singleJobDetails?.educationRequiement || "N/A"}</div>
              <div>
                {singleJobDetails?.noOfOpening
                  ? `${singleJobDetails?.noOfOpening} Openings`
                  : "N/A"}
              </div>
            </div>

            <div className="skill-section-job-card d-flex align-items-center flex-wrap gap-2">
              {singleJobDetails?.skills?.map((data, index) => (
                <div key={index}>{data}</div>
              ))}
            </div>

            <div className="button-section-jobCard d-flex flex-wrap gap-2 mt-3">
              {singleJobDetails?.status === "Open" ? (
                <EventButton
                  onClick={() =>
                    closeJobOpening(
                      singleJobDetails?.status,
                      singleJobDetails?._id
                    )
                  }
                >
                  <span>Close Hiring</span>{" "}
                  {spinners && <Spinner animation="border" role="status" />}
                </EventButton>
              ) : (
                <button className="blosed-job-btn py-2">
                  <span>Closed</span>{" "}
                  {spinners && <Spinner animation="border" role="status" />}
                </button>
              )}

              <StepperBackButton onClick={shareLink}>
                Share <IoMdShare fontSize={18} />
              </StepperBackButton>
            </div>

            <div className="job-description-container mt-1">
              <div>
                <h1>Job Description</h1>
              </div>
              <div
                dangerouslySetInnerHTML={{
                  __html: convertHtmlToText(singleJobDetails?.jobDescription),
                }}
              />
            </div>
          </div>
        ) : (
          <Skeleton
            avatar
            paragraph={{
              rows: 5,
            }}
          />
        )}
      </div>
    </>
  );
}
